import React from "react";
import Alert from "@amzn/meridian/alert";
import { SELECT_BUSINESS_SPACE_PROMPT } from "../../constants";

export default function SelectBusinessSpacePrompt() {
  return <Alert type="informational">{SELECT_BUSINESS_SPACE_PROMPT}</Alert>;
}
